module.exports = __webpack_public_path__ + "img/lize03.91f040bd.png";